import {gridExport} from '../project-review/all';
import {getParamString} from './ssrsParams';

const $catSelect = $('#Categories');
const $reportSelect = $('#ReportList');
let $exportSelect;
let reportName = '';
let gridData = [];
let gridColumns = [];
let reportUrls = [];
let reportPath = $('#encodedReportUrl').val();

export default function () {
    $exportSelect = $('#reportExport');
    let $displayName = $('#ReportDisplayName');
    reportName = $displayName.val().replace(/\s/g, '_');
    generateGrid();
    attachExportEvent();
    attachCloseReportEvent();

    $('#ssrsReportViewer').on('load', function () {
        hideLoader();
        $(document).trigger('ssrs:ReportBuilt');
    });
}

const generateGrid = () => {
    let $tempGrid = $('#tempGrid');
    if ($tempGrid.length) {
        let sproc = $('#reportGrid').attr('data-sproc'), sourceUrl = $('#SourceUrl').val(), paramString = '';

        if (sourceUrl.indexOf('paramString=') !== -1) {
            paramString = sourceUrl.split('paramString=')[1];
        }

        //Create DataSource
        let _dataSource = new kendo.data.DataSource({
            transport: {
                create: {
                    url: `/Reporting/Ssrs/GetGridData?sproc=${sproc}&paramString=${paramString}`,
                    type: 'POST',
                    dataType: 'json'
                }, read: {
                    url: `/Reporting/Ssrs/GetGridData?sproc=${sproc}&paramString=${paramString}`,
                    type: 'POST',
                    dataType: 'json'
                }
            }, schema: {
                data: function (data) {
                    let dataArray = [];
                    if (data.length > 0) {
                        let propertyArray = [];
                        //Get Properties from data
                        for (let property in data[0]) {
                            let locked = true;
                            if (property != null) {
                                let tempObj = {
                                    field: property.replace(/\s|-/g, ''),
                                    title: property,
                                    hidden: false,
                                    minResizableWidth: 100,
                                    locked: !locked
                                };
                                propertyArray.push(tempObj);
                            }
                        }

                        for (let item in data) {
                            let tempData = data[item];
                            for (let field in tempData) {
                                let newKey = field.replace(/\s|-/g, '');
                                if (field !== newKey) {
                                    Object.defineProperty(tempData, newKey, Object.getOwnPropertyDescriptor(tempData, field));
                                    delete tempData[field];
                                }
                            }
                            dataArray.push(tempData);
                        }

                        gridColumns = propertyArray;
                        gridData = dataArray;
                    }
                    createActualGrid();
                    return dataArray;
                }
            }
        });

        //Create base grid Grid
        $tempGrid.kendoGrid({
            dataSource: _dataSource
        }).remove();
    }
};

const attachExportEvent = () => {
    if ($exportSelect.length) {
        $exportSelect.change(function () {
            if (this.value !== '0') {
                let $drilldownReport = $('#drilldownReport');
                let dateTime = new Date(), downloadLink = document.createElement('a'), thisReportName = reportName;
                if ($drilldownReport.length && $drilldownReport.val() !== '') {
                    let reportUrl = $drilldownReport.val().split('PortalReports%2F')[1];
                    reportUrl = reportUrl.split('&rs')[0];
                    reportUrl = reportUrl.split('%2F');
                    let endReportName = reportUrl[1].indexOf('&');
                    thisReportName = reportUrl[1].substr(0, endReportName);
                    let params = reportUrl[1].substr(endReportName + 1).replace(/=/g, ':').replace(/&/g, ',');
                    downloadLink.href = `/Reporting/Ssrs/${this.value}?category=${reportUrl[0]}&reportName=${thisReportName}&paramString=${params}`;
                    reportUrls.push(downloadLink.href);
                } else {
                    downloadLink.href = `/Reporting/Ssrs/${this.value}?category=${$catSelect.val()}&reportName=${$reportSelect.val()}&paramString=${getParamString()}`;
                }

                let extension = '';

                switch (this.value) {
                    case 'GetCsv' : {
                        extension = '.csv';
                        break;
                    }
                    case 'GetExcel' : {
                        extension = '.xlsx';
                        break;
                    }
                    case 'GetWord' : {
                        extension = '.docx';
                        break;
                    }
                    case 'GetPdf' : {
                        extension = '.pdf';
                        break;
                    }
                    case 'GetXml' : {
                        extension = '.xml';
                        break;
                    }
                    default : {
                        break;
                    }
                }

                downloadLink.download = `${thisReportName}_${dateTime.getFullYear()}${(dateTime.getMonth() + 1)}${dateTime.getDate()}${extension}`;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                $(downloadLink).remove();
                $exportSelect.data('kendoDropDownList').select(0);
            }
        });
        // hideLoader();
    }
};

const attachCloseReportEvent = () => {
    let $closeReport = $('#ssrsCloseReport');
    if ($closeReport.length) {
        $closeReport.click(function () {
            $('#viewReport').hide();
        })
    }
};

const createActualGrid = () => {
    let $reportGrid = $('#reportGrid');
    if ($reportGrid.length) {
        let dateTime = new Date(),
            fileName = `${reportName}_${dateTime.getFullYear()}${(dateTime.getMonth() + 1)}${dateTime.getDate()}.xlsx`;
        $reportGrid.kendoGrid({
            columns: gridColumns, dataSource: {
                data: gridData, pageSize: 20
            }, resizable: true, toolbar: kendo.template('<input id="export" style="float:right;" />'), excel: {
                fileName: fileName,
                proxyURL: 'https://demos.telerik.com/kendo-ui/service/export',
                filterable: true,
                allPages: true
            }, mobile: false, scrollable: true, sortable: {
                mode: 'multiple'
            }, filterable: true, /*groupable: true,*/
            dataBound: function (e) {
                hideLoader();
                for (let i = 0; i < this.columns.length; i++) {
                    this.autoFitColumn(i);
                }
            }, pageable: {
                alwaysVisible: false, pageSizes: true, buttonCount: 5
            }
        });

        //Add Grid Export Functionality
        gridExport();
        $(document).trigger('ssrs:ReportBuilt');
    }
};

const hideLoader = () => {
    $('#runReport').show(0);
    $('#viewReport').show(0);
    $('#loading').hide(0);
};

export const initSsrsViewer = () => {
    initReportViewerControls();

    $('.FirstPage, .ViewReport, .Refresh').click(function () {
        if (!$(this).attr('disabled')) {
            viewReportPage(1);
        }
    });

    $('.PreviousPage').click(function () {
        if (!$(this).attr('disabled')) {
            let page = parseInt($('#ReportViewerCurrentPage').val()) - 1;
            viewReportPage(page);
        }
    });

    $('.NextPage').click(function () {
        if (!$(this).attr('disabled')) {
            var page = parseInt($('#ReportViewerCurrentPage').val()) + 1;
            viewReportPage(page);
        }
    });

    $('.LastPage').click(function () {
        if (!$(this).attr('disabled')) {
            var page = parseInt($('#ReportViewerTotalPages').text());
            viewReportPage(page);
        }
    });

    $('#ReportViewerCurrentPage').change(function () {
        var page = $(this).val();
        viewReportPage(page);
    });

    $('[data-export-format]').on('click', function () {
        let $that = $(this);
        exportReport($that);
    });

    $('#ReportViewerSearchText').on('keypress', function (e) {
        if (e.keyCode == 13) {
            // Cancel the default action on keypress event
            e.preventDefault();
            findText();
        }
    });

    $('.FindTextButton').click(function () {
        findText();
    });

    $('.Print').click(function () {
        printReport();
    });

    $('.backToParent').click(function () {
        $('#drilldownReport', window.parent.document).val(reportUrls.pop());
    });

    $('#ssrsExportMenu').kendoMenu();

    viewReportPage(1); //load the report
};

const initReportViewerControls = () => {
    try {
        ReportViewer_Register_OnChanges();
    } catch (e) {
    }
};

const reloadParameters = () => {
    let params = $('.ParametersContainer :input').serializeArray();
    let urlParams = $.param(params);

    showLoadingProgress('Updating Parameters...');

    $.get('/Reporting/SsrsReportViewer/ReloadParameters/?reportPath=' + reportPath + '&' + urlParams).done(function (data) {
        if (data != null) {
            $('.Parameters').html(data);
            _initializeReportViewerControls();

            if ($('.ReportViewerContent').find('div').length != 1) {
                $('.ReportViewerContent').html('<div class="ReportViewerInformation">Please fill parameters and run the report...</div>');
            }
        }
        hideLoadingProgress();
    });
};

const showLoadingProgress = (message) => {
    hideLoadingProgress();

    if (!message.length) message = 'Loading';

    $('.ReportViewerContent').hide();
    $('.ReportViewerContentContainer')
        .append('<div class="loadingContainer"><div style="margin: 0 auto; width: 100%; text-align: center; vertical-align: middle;"><h2><i class="glyphicon glyphicon-refresh gly-spin"></i>' + message + '</h2></div></div>');
};

const hideLoadingProgress = () => {
    $('.loadingContainer').remove();
    $('.ReportViewerContent').show();
};

const printReport = () => {
    var params = $('.ParametersContainer :input').serializeArray();
    var urlParams = $.param(params);

    window.open('/Reporting/SsrsReportViewer/PrintReport/?reportPath=' + reportPath + '&' + urlParams, '_blank');
};

const findText = () => {
    $('.ReportViewerContent').removeHighlight();
    var searchText = $('#ReportViewerSearchText').val();
    if (searchText != undefined && searchText != null && searchText != '') {
        showLoadingProgress('Searching Report...');
        var params = $('.ParametersContainer :input').serializeArray();
        var urlParams = $.param(params);

        var page = parseInt($('#ReportViewerCurrentPage').val());

        $.get('/Reporting/SsrsReportViewer/FindStringInReport/?reportPath=' + reportPath + '&page=' + page + '&searchText=' + searchText + '&' + urlParams).done(function (data) {
            if (data > 0) {
                viewReportPage(data, function () {
                    $('.ReportViewerContent').highlight(searchText);
                    hideLoadingProgress();
                });
            } else {
                $('.ReportViewerContent').highlight(searchText);
                hideLoadingProgress();
            }
        });
    }
};

const viewReportPage = (page, afterReportLoadedCallback) => {
    showLoadingProgress('Loading Report Page...');
    var params = $('.ParametersContainer :input').serializeArray();
    var urlParams = $.param(params);
    var totalPages = parseInt($('#ReportViewerTotalPages').text());

    if (page == undefined || page == null || page < 1) {
        page = 1;
    } else if (page > totalPages) {
        page = totalPages;
    }

    $.get('/Reporting/SsrsReportViewer/ViewReportPage?reportPath=' + reportPath + '&page=' + page + '&' + urlParams)
        .done(function (data) {
            updateReportContent(data);
            hideLoadingProgress();
            $('#loading').hide();
            $('#runReport').show();
            $('#viewReport').show();

            attachDrillDownReportLink();
            if (afterReportLoadedCallback && typeof (afterReportLoadedCallback) == 'function') {
                afterReportLoadedCallback();
            }
            $(document).trigger('ssrs:ReportBuilt');
        })
        .fail(function (data) {
            $('.ReportViewerContent').html('<div class=\'ReportViewerError\'>Report failed to load, check report parameters...</div>');
            hideLoadingProgress();
        });
};

const exportReport = (e) => {
    var params = $('.ParametersContainer :input').serializeArray();
    var urlParams = $.param(params);
    var format = $(e).attr('data-export-format');

    window.location.href = '/Reporting/SsrsReportViewer/ExportReport/?reportPath=' + reportPath + '&format=' + format + '&' + urlParams;
};

const updateReportContent = (data) => {
    if (data != undefined && data != null) {
        $('#ReportViewerCurrentPage').val(data.CurrentPage);
        $('#ReportViewerTotalPages').text(data.TotalPages);
        $('.ReportViewerContent').html($.parseHTML(data.Content));

        if (data.TotalPages <= 1) {
            $('.FirstPage').attr('disabled', true);
            $('.PreviousPage').attr('disabled', true);
            $('.NextPage').attr('disabled', true);
            $('.LastPage').attr('disabled', true);
        } else {
            $('.FirstPage').attr('disabled', false);
            $('.PreviousPage').attr('disabled', false);
            $('.NextPage').attr('disabled', false);
            $('.LastPage').attr('disabled', false);
        }
    }
};

const attachDrillDownReportLink = () => {
    let $drilldownReport = $('#drilldownReport', parent.document);
    if ($drilldownReport.length) {
        $('.ReportViewerContentContainer a').click(function () {
            $drilldownReport.val(this.href);
        });
    }
};